import { type UserNotificationSettings, userNotificationSettingsSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'src/useAuth';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

const userNotificationsResponseSchema = z.array(userNotificationSettingsSchema);

export function useUserNotifications() {
  const { authenticated, token } = useAuth();

  const {
    data: notifications,
    error,
    isLoading,
  } = useQuery<UserNotificationSettings[]>({
    queryKey: queryKeys.getUserNotifications(),
    queryFn: () => get({ url: '/alerts/notifications', schema: userNotificationsResponseSchema }),
    enabled: authenticated || !!token,
  });

  return {
    notifications,
    error,
    isLoading,
  };
}
